// Translations
import form from '../sections/form/translations/ru'

// Translation: Register > Landing (Russian)
export default Object.freeze({
	sections: { form }
})
